import BaseCarousel from '../abstracts/BaseCarousel';

export default class CarouselComponent extends BaseCarousel {
  constructor(element) {
    super(element);
    this.mount(this.$el, this.$options);
  }
}
